import './login.css';
import loginBg from '../../assets/loginBg.jpg';
import loginMan from '../../assets/loginMan.png';
import c2sLogo from '../../assets/C2Slogo.png';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Spinner from '../../components/Spinner/spinner';
import { InteractionStatus } from '@azure/msal-browser';
import * as microsoftTeams from "@microsoft/teams-js";

const isInIframe = window !== window.parent;
export const Login = () => {
    const { instance, accounts, inProgress } = useMsal();
    const navigate = useNavigate();
    const { userData } = useSelector(state => state?.user);
    const userType = localStorage.getItem('userType');
    const userTypeRole = userData?.userTypes?.find(type =>
    type?.userType?.toLowerCase().includes(userType?.toLowerCase())
  );
  const isSuperAdmin = userTypeRole?.userTypeRoleId === 1;
  const isHr = [2].includes(userTypeRole?.userTypeRoleId);
  const isAccounts = [3].includes(userTypeRole?.userTypeRoleId);

    useEffect(() => {
        if (accounts.length > 0) {

            navigate(isSuperAdmin ? '/admin/timesheet-list': isAccounts ?'/user/employees/timesheets':isHr?'/hr/employees/timesheets':'/user/timesheet');
        }
    }, [accounts, navigate]);

    const handleLogin = async () => {
        try {
            await instance.loginRedirect(loginRequest);
        } catch (error) {
            console.error("Login failed:", error);
        }
    };
  
    useEffect(() => {
      if (inProgress === InteractionStatus.None) {
        if (isInIframe) {
          instance.loginPopup(loginRequest).catch(error => {
            console.error("Login popup failed in iframe:", error);
          });
        } else {
          instance.loginRedirect(loginRequest).catch(error => {
            console.error("Login redirect failed:", error);
          });
        }
      }
    }, [inProgress, instance]);
    return <Spinner/>;
};
